import React, {useState} from "react";
import { useTranslation } from "next-i18next";
import {
    Collaps,
    Expand,
    MwSmallIcon,
} from "../../components/v2/icons";
import {GetStaticProps} from "next";
import {getFirstFewPosts} from "../../lib/api";
import ProductResources from "../../components/v2/product/product-resource";
import Link from "next/link";
import Card from "../../components/v2/cards/card";
import PlatformHeroSection from "../../components/v2/common/platform-hero";
import PlatformFeatures from "../../components/v2/common/platform-feature";

export default function UnifiedExperience() {
    const { t } = useTranslation("common");

    const platformCardsRaw = t('platform.unifiedExperience.cards', { returnObjects: true }) as any
    const platformCards = Array.isArray(platformCardsRaw) ? platformCardsRaw : []

    const resource = [] as any[]

    const platformDataDrivenRaw = t('platform.unifiedExperience.features.dataDriven', { returnObjects: true }) as any
    const platformDataDriven = Array.isArray(platformDataDrivenRaw) ? platformDataDrivenRaw : []
    const resourcesRaw = t('platform.unifiedExperience.resources', { returnObjects: true }) as any
    const resources = Array.isArray(resourcesRaw) ? resourcesRaw : []

    return (
        <>
            <div className={"platform-main"}>

                <PlatformHeroSection title={<h1>{t('platform.unifiedExperience.hero.title')} <span
                    className={"text-gradient"}>{t('platform.unifiedExperience.hero.titleHighlight')}</span> <br/> {t('platform.unifiedExperience.hero.titleSuffix')}</h1>}
                                     img={"/images/platform/streamline-your-data-teams-with-unified-observability.png"} imgMobile={"/images/platform/streamline-your-data-teams-with-unified-observability-mobile.webp"} preloadImg
                                     imgAlt={t('platform.unifiedExperience.hero.imageAlt')}
                                     className={"platform-page"}/>

                <section className={'mw-card platform-inner'}>
                    <div className={'container'}>
                        <div className={'d-flex card-items'}>
                            <div className={'card-item'}>
                                <div className={'section-tag testimonial pd-right'}><MwSmallIcon/> {t('platform.shared.benefitsTag')}</div>
                                <h2><span className={"text-gradient"}>{t('platform.unifiedExperience.section.titlePrefix')}</span>{t('platform.unifiedExperience.section.titleSuffix')}</h2>
                            </div>
                            {
                                platformCards.map((item, index) => {
                                    return <Card heading={item.heading}
                                                 description={item.description}
                                                 isHeading={item.isHeading}/>
                                })
                            }
                        </div>
                    </div>
                </section>


                <PlatformFeatures dataDriven={platformDataDriven} title={<h2>{t('platform.unifiedExperience.features.titlePrefix')}<span
                    className={"text-gradient"}>{t('platform.unifiedExperience.features.titleHighlight')}</span>{t('platform.unifiedExperience.features.titleSuffix')}</h2>}
                                  description={t('platform.unifiedExperience.features.description')}/>

                <ProductResources resources={resources} title={t('platform.shared.resourcesTitle')}/>
            </div>
        </>
    )
}

export const getStaticProps: GetStaticProps = async () => {
    const posts = await getFirstFewPosts();
    return {
        props: {
            posts,
        },
    };
};